import { Drawer } from '@mui/material';
import Image from 'next/image';
import { IBottomDrawerProps } from '../../../interfaces/components/drawer.interface';

const BottomDrawer: React.FunctionComponent<IBottomDrawerProps> = ({
  isOpen,
  handleClose,
  children,
  title = '',
  subtitle = '',
}) => {
  return (
    // only visible on mobile
    <Drawer
      className="!z-[10000] lg:hidden"
      anchor="bottom"
      open={isOpen}
      onClose={handleClose}
      PaperProps={{
        square: false,
        style: {
          borderTopLeftRadius: '10px',
          borderTopRightRadius: '10px',
          borderBottomLeftRadius: '0px',
          borderBottomRightRadius: '0px',
          zIndex: '10000px !important',
        },
      }}
    >
      <div className="flex items-center justify-between p-3 px-5 pb-2 text-xl font-bold">
        <div className="flex flex-col gap-2">
          {title}
          <div className="text-sm font-thin text-gray-500">{subtitle}</div>
        </div>

        <div className="cursor-pointer" onClick={handleClose}>
          <Image src="/icons/x.svg" width={10} height={10} />
        </div>
      </div>
      <div className="h-full overflow-y-scroll">{children}</div>
    </Drawer>
  );
};

export default BottomDrawer;
